import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    current: {},
    currentList: [],
    payItems: [],
    manMachineItems: [],
    manMachineList: [{name: 'aaa', _id: 123}, {name: 'aaad', _id: 1213}]
  },
  getters: {
    newPayItems (state) {
      const list = state.payItems
        .filter(item => item.isApproved || item.previous)
        .map((element) => {
          return {...element, doneQuantity: 0, isSelected: false, item: element._id}
        })
      return list
    },
    newManMachineItems (state) {
      const list = state.manMachineItems.map((element) => { return {...element, doneQuantity: 0, item: element._id} })
      return list
    },
    newDailyRecord (state) {
      const list = {...state.current}
      list.payItems.forEach(item => {
        item.isSelected = false
        item.newSumQuantity = parseFloat(item.doneQuantity) + parseFloat(item.totalQuantity)
        list.constructionItems.forEach(ele => {
          if (item._id === ele.item && item.isSelected === false) {
            item.isSelected = true
            list.constructionItems[list.constructionItems.findIndex(ele1 => ele1._id === ele.item)] = item
          }
        })
        list.materialItems.forEach(ele => {
          if (item._id === ele.item && item.isSelected === false) {
            item.isSelected = true
            list.materialItems[list.materialItems.findIndex(ele1 => ele1._id === ele.item)] = item
          }
        })
      })

      list.manMachineUsage.forEach(item => {
        item.totalQuantity += item.doneQuantity
      })
      return list
    }
  },
  mutations: {
    setCurrent (state, current) {
      state.current = current
    },
    setCurrentList (state, currentList) {
      state.currentList = currentList
    },
    setPayItems (state, payItems) {
      state.payItems = payItems
    },
    setManMachineItems (state, manMachineItems) {
      state.manMachineItems = manMachineItems
    }
  },
  actions: {
    async getDailyRecordAndStore ({commit, state}, condition) {
      commit('setCurrent', await api.getDailyRecord(condition))
    },
    async getDailyRecordListAndStore ({rootState, commit, state}, filterOptions) {
      commit('setCurrentList', await api.getDailyRecords(rootState.project.current._id, filterOptions))
    },
    async add ({dispatch, state}, condition) {
      await api.addDailyRecord(condition)
      await dispatch('getDailyRecordListAndStore')
    },
    async update ({dispatch, state}, condition) {
      await api.updateDailyRecord(state.current._id, condition)
      await dispatch('getDailyRecordListAndStore')
    },
    async delete ({dispatch, state}, condition) {
      await api.deleteDailyRecord(condition)
      await dispatch('getDailyRecordListAndStore')
    },
    async getPayItems ({rootState, commit, state}, condition) {
      commit('setPayItems', await api.getPayItems(rootState.project.current._id, condition))
    },
    downloadFile ({state}, condition) {

    },
    async getManMachineItems ({rootState, commit, dispatch, state}, condition) {
      commit('setManMachineItems', await api.getManMachineItems(rootState.project.current._id, condition))
    },
    async downloadDailyRecord ({rootState, commit, dispatch, state}, dailyRecord) {
      let result = await api.downloadDailyRecord(dailyRecord._id)
      require('downloadjs')(result, `施工日誌第一聯_${dailyRecord.fillInAt}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    },
    async downloadDailyPayItems ({rootState, commit, dispatch, state}, dailyRecord) {
      let result = await api.downloadDailyPayItems(dailyRecord._id)
      require('downloadjs')(result, `施工日誌第二聯_${dailyRecord.fillInAt}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    },
    async batchDownload ({rootState, commit, dispatch, state}, dailyRecordIds) {
      let result = await api.downloadDailyRecords(dailyRecordIds)
      require('downloadjs')(result, `批次下載_施工日誌.zip`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dailyRecord.js